<template>
  <div
    class="flex flex-col items-center justify-center top-0 left-0 w-full h-full overflow-hidden"
    :class="{
      'fixed top-0 left-0 w-full h-full': fullscreen,
      absolute: !fullscreen,
    }"
  >
    <div class="w-full h-full bg-gray-800 bg-opacity-80 absolute" />
    <Vue3Lottie
      :height="height"
      :width="width"
      :animationData="hypeloader"
    />
    <h1 v-if="title" class="text-white text-2xl mt-5">
      {{ title }}
    </h1>
  </div>
</template>

<script>
import { Vue3Lottie } from "vue3-lottie";
import "vue3-lottie/dist/style.css";
import hypeloader from "../animations/HypeLoader.json";
export default {
  name: "Loader",
  components: {
    Vue3Lottie,
  },
  props: {
    title: {
      type: String,
    },
    fullscreen: {
      type: Boolean,
    },
    small: Boolean,
    height: {
      type: [Number, String],
      default: 150,
    },
    width: {
      type: [Number, String],
      default: 150,
    },
  },
  data() {
    return {
      hypeloader,
    };
  },
};
</script>

<style scoped>
.loading {
  z-index: 12;
}
.loading-img {
  z-index: 13;
}
.loading-text {
  z-index: 13;
}
</style>
